// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd60a60b","732":"5a301367","977":"de8e97a7"}[chunkId] + ".chunk.js";
};